import React from 'react';
//<88181> 		 
const ListadoEspecTecnicas = props => (
  <tbody>
    {
      props.etsvehiculo.length ?
        props.etsvehiculo.map(bean => (
          <tr key={bean.codigo}>
            <td>{bean.codigo}</td>			
            <td>{bean.descripcion}</td>			
            <td>{bean.valor}</td>
			<td>{bean.indInactivo}</td>
          </tr>
        )) :
        <tr>
          <td colSpan={9}>No hay resultados</td>
        </tr>
    }
  </tbody>
);

export default ListadoEspecTecnicas;







// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/ListadoEspecTecVehiculo.js